// frontend/app/components/lessonPlans/teachsense/TeachSenseTabs.js
//
// Two views of one surface. TeachSense extends class insights rather than
// replacing it, so the tab a teacher already knows stays selected on open and
// nothing they were reading yesterday moved.

import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";

export const INSIGHTS_TAB = "insights";
export const TEACHSENSE_TAB = "teachsense";

const TABS = [
  { key: INSIGHTS_TAB, label: "Class insights", icon: "chart-box-outline" },
  { key: TEACHSENSE_TAB, label: "TeachSense", icon: "radar" },
];

const TeachSenseTabs = ({ active, onChange, colors, t }) => {
  const translate = t || ((value) => value);

  return (
    <View
      testID="teachsense-tabs"
      accessibilityRole="tablist"
      style={[styles.bar, { borderBottomColor: colors.border }]}
    >
      {TABS.map((tab) => {
        const selected = active === tab.key;
        const accent = selected ? colors.accentPrimary : colors.textMuted;
        return (
          <TouchableOpacity
            key={tab.key}
            testID={`teachsense-tab-${tab.key}`}
            accessibilityRole="tab"
            accessibilityState={{ selected }}
            accessibilityLabel={translate(tab.label)}
            onPress={() => onChange(tab.key)}
            style={[
              styles.tab,
              { borderBottomColor: selected ? colors.accentPrimary : "transparent" },
            ]}
          >
            <MaterialCommunityIcons name={tab.icon} size={15} color={accent} />
            <Text style={[styles.label, { color: accent }]}>{translate(tab.label)}</Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  bar: {
    flexDirection: "row",
    alignSelf: "flex-start",
    borderBottomWidth: 1,
    marginBottom: 16,
    gap: 4,
  },
  tab: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    paddingHorizontal: 12,
    paddingVertical: 9,
    // Sits on the bar's own 1px rule, so the selected tab reads as attached to
    // the content below it rather than as a floating underline.
    marginBottom: -1,
    borderBottomWidth: 2,
  },
  label: { fontSize: 13, fontWeight: "700" },
});

export default TeachSenseTabs;
